import Box from "@memorang/ui/src/components/Box";
import Button from "@memorang/ui/src/components/Button";
import CardContainer from "@memorang/ui/src/components/CardContainer";
import { TextSkeleton } from "@memorang/ui/src/components/ChatUI/TextSkeleton";
import MarkdownRenderer from "@memorang/ui/src/components/MarkdownRenderer";
import { Card, TouchableRipple } from "react-native-paper";

export type SessionAnalysisCardProps = {
	title: string;
	subtitle: string;
	buttonText: string;
	sessionAnalysis?: string;
	loading?: boolean;
	onToggleCompleteReport: () => void;
	appFont?: string;
	contentHeight?: number;
};

const SessionAnalysisCard = ({
	title,
	subtitle,
	buttonText,
	sessionAnalysis = "",
	loading = false,
	onToggleCompleteReport,
	appFont,
	contentHeight = 150,
}: SessionAnalysisCardProps) => {
	const CardContent = () => {
		return (
			<Card.Content
				style={{
					paddingHorizontal: 16,
					height: contentHeight,
					overflow: "hidden",
					paddingTop: 8,
				}}
			>
				<MarkdownRenderer
					text={sessionAnalysis}
					variant="explanation"
					appFont={appFont}
				/>
			</Card.Content>
		);
	};

	return (
		<CardContainer
			title={title}
			subtitle={subtitle}
			icon="head-lightbulb-outline"
			actions={
				<Card.Actions>
					<Button onPress={onToggleCompleteReport} mode="text">
						{buttonText}
					</Button>
				</Card.Actions>
			}
		>
			<TouchableRipple
				onPress={onToggleCompleteReport}
				rippleColor={"transparent"}
			>
				{loading || !sessionAnalysis ? (
					<Box
						paddingVertical={16}
						paddingHorizontal={16}
						height={contentHeight}
						alignItems="center"
					>
						<TextSkeleton numLines={4} height={18} />
					</Box>
				) : (
					<CardContent />
				)}
			</TouchableRipple>
		</CardContainer>
	);
};

export default SessionAnalysisCard;
